'use client';

import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface ChanceIndicatorProps {
  percentage: string;
}

export function ChanceIndicator({ percentage }: ChanceIndicatorProps) {
  const { t } = useT();
  const numericValue = parseFloat(percentage.replace('%', '').replace('<', ''));

  // Design (Landing.dc.html / Pages.dc.html): the chance is FLAT text, not a ring —
  // a mono 20px % coloured by likelihood (green high / amber mid / red low) with a
  // small uppercase "CHANCE" label beneath, right-aligned. Same `percentage` prop,
  // so every existing caller keeps working.
  let color: string;
  if (numericValue >= 50) color = '#4ec38a';
  else if (numericValue >= 30) color = '#e8b046';
  else color = '#e0664f';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        textAlign: 'right',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'var(--font-plex-mono), IBM Plex Mono, monospace',
          fontSize: '20px',
          fontWeight: 600,
          color,
          lineHeight: 1,
        }}
      >
        {percentage}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'var(--font-plex-mono), IBM Plex Mono, monospace',
          fontSize: '9.5px',
          color: 'text.disabled',
          fontWeight: 500,
          lineHeight: 1.2,
          mt: '4px',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
        }}
      >
        {t('market.chance')}
      </Typography>
    </Box>
  );
}
